import requestCommon from "@/components/web-interface/requestCommon";
const state = {
  referenceData: null,
  messagesData: null,
};
const actions = {
  getReferenceData(context, data) {
    return requestCommon.getInfo(
      "/references" + "/" + data.type,
      data,
      null,
      context,
      "getReferenceDataSuccessHandler",
      "getReferenceDataErrorHandler"
    );
  },
  getAllMessages(context, data) {
    return requestCommon.getInfo(
      "/events/files",
      null,
      null,
      context,
      "getAllMessagesSuccessHandler",
      "getAllMessagesErrorHandler",
    );
  }
}
const mutations = {
  getReferenceDataSuccessHandler(state, data) {
    state.referenceData = data.server.data;
  },
  getReferenceDataErrorHandler(context, error) {
    console.log(error);
  },
  getAllMessagesSuccessHandler(state, data) {
    state.messagesData = data.server.data;
  },
  getAllMessagesErrorHandler(context, error) {
    console.log(error);
  },
};
const getters = {};
export const commonStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}